import axios from 'axios'
import { API_CONFIG, joinApiUrl } from '../config/api.config'
import logger from '../utils/logger'

export default function apiClient(baseUrl = API_CONFIG.BASE_URL) {

    async function request(endpoint, options = {}, retryCount = 0) {
        const maxRetries = options.maxRetries !== undefined ? options.maxRetries : 3;
        const retryDelay = options.retryDelay !== undefined ? options.retryDelay : 1000;
        const rawResponse = options.rawResponse === true;
        
        try {
            const url = joinApiUrl(baseUrl, endpoint)
            const response = await axios({
                url,
                method: options.method || 'GET',
                data: options.body,
                params: options.params,
                headers: options.headers,
                ...options.config
            })
            return rawResponse ? response : response.data
        } catch (err) {
            // Loggear todos los errores de API
            logger.apiError(endpoint, err, {
                method: options.method || 'GET',
                body: options.body,
                params: options.params,
            });
            
            // El interceptor global puede rechazar error.response directamente;
            // normalizamos para manejar ambos casos.
            const response = err.response || err;
            const errorData = response?.data;
            const status = response?.status || err.response?.status;

            // Si es un error de respuesta HTTP, lanzar solo el mensaje o los datos
            if (response && errorData !== undefined) {
                // Manejar específicamente error 429 después de todos los reintentos
                if (status === 429) {
                    throw new Error('Demasiadas peticiones. Por favor, espera un momento y recarga la página.');
                }

                // Si errorData es un objeto con mensaje, usar el mensaje
                if (errorData && typeof errorData === 'object' && errorData.message) {
                    throw new Error(errorData.message);
                }
                // Si errorData es un objeto con msg, usar el msg
                if (errorData && typeof errorData === 'object' && errorData.msg) {
                    throw new Error(errorData.msg);
                }
                // Si errorData es un objeto con error, usar el error
                if (errorData && typeof errorData === 'object' && errorData.error) {
                    throw new Error(typeof errorData.error === 'string' ? errorData.error : JSON.stringify(errorData.error));
                }
                // Si errorData es un string, lanzarlo como error
                if (typeof errorData === 'string') {
                    throw new Error(errorData);
                }
                // Si no, lanzar un error genérico
                throw new Error(response.statusText || 'Error en la petición');
            }
            // Si es un error de red u otro tipo
            throw new Error(err.message || 'Error desconocido');
        }
    }

    function get(endpoint, opts = {}) {
        return request(endpoint, { ...opts, method: 'GET' })
    }

    function post(endpoint, body, opts = {}) {
        return request(endpoint, { ...opts, method: 'POST', body })
    }

    function put(endpoint, body, opts = {}) {
        return request(endpoint, { ...opts, method: 'PUT', body })
    }

    function del(endpoint, opts = {}) {
        return request(endpoint, { ...opts, method: 'DELETE' })
    }

    return { get, post, put, del }
}
